class ConfiguratorForm extends HTMLElement {
    constructor() {
      super();
  
      this.drawer = document.querySelector('configurator-drawer');
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.backButton = this.querySelector('button.drawer__back');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.footer = this.querySelector('.drawer__footer');
      this.framePrice = this.querySelector('.drawer__footer #FramePrice .price_container').dataset.amount / 100

      this.possibleNextSteps = ['extras'];
      this.nextStepsHtml = {};
      this.previousStepHtml = undefined;

      this.renderFooter();
      this.getNextSteps();
      this.getPreviousSteps();
  
      this.initDropdowns();
    }
  
    initDropdowns() {
      const dropdowns = this.form.querySelectorAll('.drawer__form_option.dropdown ul');
      const dropdownButtons = this.form.querySelectorAll('.drawer__form_option.dropdown button');
      if (!dropdownButtons) return;

      // remove "addition" option if not applicable
      if (!['double', 'work'].includes(this.drawer.bundle.focus)) {
        this.form.querySelector('label[for="addition-right"]')?.parentElement.remove()
      }
  
      // open or close dropdown on button click
      dropdownButtons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          const dropdown = evt.target.closest('label').querySelector('ul');
  
          dropdown.classList.contains('opened') ? dropdown.classList.remove('opened') : dropdown.classList.add('opened');
        });
      });
  
      // manage selected dropdown value
      dropdowns.forEach((dropdown) => {
        dropdown.addEventListener('click', (evt) => {
          const li = evt.target.closest('li');
          const selectedValue = li.dataset.value;
          dropdown.classList.remove('opened');
  
          const respectiveButton = li.closest('label').querySelector('button');
          const respectiveInput = li.closest('label').querySelector('input');
          respectiveButton.querySelector('.button-text').textContent = selectedValue;
          respectiveInput.value = selectedValue;
        });
      });
  
      // close any dropdown on click outside
      this.addEventListener('click', (evt) => {
        if (![...dropdowns, ...dropdownButtons].some((dropdown) => dropdown.contains(evt.target)))
          dropdowns.forEach((dropdown) => dropdown.classList.remove('opened'));
      });
    }
  
    getFormValue() {
      const formData = new FormData(this.form);
      return [...formData.entries()];
    }
  
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
  
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
  
      const formData = new FormData(this.form);
  
      this.drawer.bundle.acuity = {
        sphere: {
          leftEye: formData.get('sphereLeft'),
          rightEye: formData.get('sphereRight'),
        },
        cylinder: {
          leftEye: formData.get('cylinderLeft'),
          rightEye: formData.get('cylinderRight'),
        },
        axis: {
          leftEye: formData.get('axisLeft'),
          rightEye: formData.get('axisRight'),
        },
        pupillaryDistance: {
          leftEye: formData.get('pupillarydistanceLeft'),
          rightEye: formData.get('pupillarydistanceRight'),
        }
      };

      // add "addition" option values if applicable
      if (this.drawer.bundle.focus == 'double' || this.drawer.bundle.focus == 'work') {
        this.drawer.bundle.acuity['addition'] = {
          leftEye: formData.get('additionLeft'),
          rightEye: formData.get('additionRight'),
        }
      }
  
      this.renderNextStep('extras');
    }
  
    getNextSteps() {
      const sections = [];
      this.possibleNextSteps.forEach((step) => sections.push('configurator-' + step));
      const url = '?sections=' + sections.join(',');
  
      fetch(url)
        .then((response) => response.json())
        .then((response) => {
          this.possibleNextSteps.forEach((step) => {
            this.nextStepsHtml[step] = response[`configurator-${step}`];
          });
          this.submitButton.removeAttribute('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    getPreviousSteps() {
      fetch('?sections=configurator-acuity')
        .then((response) => response.json())
        .then((response) => {
          this.previousStepHtml = response['configurator-acuity'];
          this.backButton.removeAttribute('disabled');
        })
        .catch((e) => {
          console.error(e);
        });
    }
  
    renderPreviousStep() {
      if (!this.previousStepHtml) return;
  
      this.drawer.renderContents(this.previousStepHtml);
    }
  
    renderNextStep(nextStep) {
      this.drawer.renderContents(this.nextStepsHtml[nextStep]);
    }

    renderFooter() {
      const chosenGlassTitle = this.drawer.bundle.glassVariant.title;
      const chosenGlassPrice = this.drawer.bundle.glassVariant.price / 100;

      const span = document.createElement('span');
      span.innerText = chosenGlassTitle;
      this.footer.querySelector('#chosenGlass').appendChild(span);
      this.footer.querySelector('#chosenGlass .price_container').innerText = chosenGlassPrice;
      this.footer.querySelector('#chosenGlass').removeAttribute('style');

      const totalPriceContainer = this.footer.querySelector('#configurator_subtotal .price_container');
      const framePrice = totalPriceContainer.dataset.amount / 100;
      const totalPrice = framePrice + chosenGlassPrice;

      totalPriceContainer.innerText = String(totalPrice.toFixed(2)).replace('.', ',');
      totalPriceContainer.dataset.amount = parseInt(totalPrice * 100);
    }
  }
  
  customElements.define('configurator-form', ConfiguratorForm);
  